import React from 'react';
import Overlay from './Overlay';

class FinishOverlay extends React.Component
{
    render()
    {
        let actions = [
            {
                "action": this.props.claimXp,
                "text": "Continue"
            }
        ];

        return (
            <Overlay
                overlayClasses="finish-overlay overlay--small"
                title="Congratulations!"
                text={"Run completed with " + this.props.playerName}
                display={this.props.display}
                name="win"
                actions={actions}
                showClose={false}
                >
                <img className="win-overlay__avatar" src={this.props.image} />
                <p className="win-overlay__quote">“The battlefield is a scene of constant chaos. The winner will be the one who controls that chaos, both his own and the enemies.”</p>
                <p className="win-overlay__author"> - Napoleon Bonaparte</p>
            </Overlay>
        );
    }
}

export default FinishOverlay;
